module.exports = __webpack_public_path__ + "static/media/TUNE_6535.832e5420.jpg";